import { render, staticRenderFns } from "./DocumentsViewer.vue?vue&type=template&id=89f79b9e&scoped=true"
import script from "./DocumentsViewer.vue?vue&type=script&lang=js"
export * from "./DocumentsViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentsViewer.vue?vue&type=style&index=0&id=89f79b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f79b9e",
  null
  
)

export default component.exports